import { I18nt } from 'utils';
import { Layout } from 'antd';
import { paths } from 'config';
import { Link } from 'react-router-dom';
import MobileMenu from './MobileMenu';
import styles from './Layout.module.less';
import goesLogo from 'assets/images/goes.logo.png';
import tuIsbmPlus from 'assets/images/tu-isbm-plus.svg';

function Header() {
	return (
		<Layout.Header className={styles.header}>
			<Link to={paths.home}>
				<img
					src={goesLogo}
					className={styles.logo}
					alt={I18nt('goes_logo_alt')}
				/>
			</Link>
			<div className={styles.isbmPlusWrapper}>
				<Link to={paths.home}>
					<img src={tuIsbmPlus} alt={I18nt('tu_isbm')} />
				</Link>
			</div>
			<div className={styles.mobileMenuWrapper}>
				<MobileMenu />
			</div>
		</Layout.Header>
	);
}

export default Header;
